import moment from "moment";

export const getPortoDefaultDate = () => {
  const today = moment().date();
  const lastMonth = ( moment().month() === 0? "12" :("0" + moment().month()).slice(-2));
  const month = ("0" + (moment().month() + 1)).slice(-2);
  const nextMonth = ("0" + (moment().add(1, 'month').month() + 1)).slice(-2);
  const year = moment().year();
  const nextYear = moment().add(1, 'year').year();
  const lastYear = moment().subtract(1, 'year').year();

  let period = {
    startDate: moment((lastMonth === "12"? lastYear : year) + "-" + lastMonth + "-22")
      .startOf("day")
      .toDate(),
    endDate: moment(year + "-" + month + "-21")
      .endOf("day")
      .subtract(3, 'hours')
      .toDate()
  };

  if (today > 21) {
    period.startDate = moment(year + "-" + month + "-22")
      .startOf("day")
      .toDate();
    period.endDate = moment((nextMonth === "01"? nextYear : year) + "-" + nextMonth + "-21")
      .endOf("day")
      .subtract(3, 'hours')
      .toDate();
  }

  return period;
};